// extracted by mini-css-extract-plugin
export default {"proofContainer":"Proof_proofContainer__hH1ax","proofWrapper":"Proof_proofWrapper__hGJHG"};